var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStillingar = function SvgStillingar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stillingar_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stillingar_svg__b)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 16c0-.73-.073-1.459-.217-2.175L30.49 11.1l-3-5.2-4.227 1.854a10.955 10.955 0 0 0-3.754-2.172L19 1h-6l-.509 4.582a10.955 10.955 0 0 0-3.754 2.172L4.51 5.9l-3 5.2 3.707 2.727a11.01 11.01 0 0 0 0 4.35L1.51 20.9l3 5.2 4.227-1.852a10.956 10.956 0 0 0 3.754 2.172L13 31h6l.509-4.582a10.956 10.956 0 0 0 3.754-2.172L27.49 26.1l3-5.2-3.707-2.727A11.05 11.05 0 0 0 27 16v0Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "stillingar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "stillingar_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgStillingar;